/*
 * Arquivo auto-gerado.
 *
 * Gerador: dev/i18n/reindexFiles.js
 *
 * Para atualizar este arquivo, execute:
 *   npm run reindex-langs
 */
/* eslint-disable */
export default function mountLanguage({
  actions,
  activeDirectory,
  adminPanel,
  alarmConfigurations,
  alarmsAndWarnings,
  analysisProcessing,
  assetInformation,
  assetList,
  base,
  buttons,
  cma,
  communicationStatusPanel,
  dateTime,
  decimalNumber,
  diagnosticsConfigurations,
  eCharts,
  entities,
  enums,
  expiredSession,
  fields,
  flagsDropdown,
  general,
  header,
  installationManager,
  listAggregator,
  login,
  messages,
  moduleInformation,
  monitoring,
  multiselect,
  myData,
  mySigma,
  networkManagement,
  networkManager,
  networkStatus,
  notification,
  pageDescription,
  pageName,
  permissions,
  profileManager,
  refreshCountdownLabel,
  regionalManager,
  reports,
  sensors,
  supervision,
  userManager,
  userMenu,
}) {
  const mounted = base;
  mounted['actions'] = actions;
  mounted['active-directory'] = activeDirectory;
  mounted['admin-panel'] = adminPanel;
  mounted['alarm-configurations'] = alarmConfigurations;
  mounted['alarms-and-warnings'] = alarmsAndWarnings;
  mounted['analysis-processing'] = analysisProcessing;
  mounted['asset-information'] = assetInformation;
  mounted['asset-list'] = assetList;
  mounted['buttons'] = buttons;
  mounted['cma'] = cma;
  mounted['communication-status-panel'] = communicationStatusPanel;
  mounted['date-time'] = dateTime;
  mounted['decimal-number'] = decimalNumber;
  mounted['diagnostics-configurations'] = diagnosticsConfigurations;
  mounted['e-charts'] = eCharts;
  mounted['entities'] = entities;
  mounted['enums'] = enums;
  mounted['expired-session'] = expiredSession;
  mounted['fields'] = fields;
  mounted['flags-dropdown'] = flagsDropdown;
  mounted['general'] = general;
  mounted['header'] = header;
  mounted['installation-manager'] = installationManager;
  mounted['list-aggregator'] = listAggregator;
  mounted['login'] = login;
  mounted['messages'] = messages;
  mounted['module-information'] = moduleInformation;
  mounted['monitoring'] = monitoring;
  mounted['multiselect'] = multiselect;
  mounted['my-data'] = myData;
  mounted['my-sigma'] = mySigma;
  mounted['network-management'] = networkManagement;
  mounted['network-manager'] = networkManager;
  mounted['network-status'] = networkStatus;
  mounted['notification'] = notification;
  mounted['page-description'] = pageDescription;
  mounted['page-name'] = pageName;
  mounted['permissions'] = permissions;
  mounted['profile-manager'] = profileManager;
  mounted['refresh-countdown-label'] = refreshCountdownLabel;
  mounted['regional-manager'] = regionalManager;
  mounted['reports'] = reports;
  mounted['sensors'] = sensors;
  mounted['supervision'] = supervision;
  mounted['user-manager'] = userManager;
  mounted['user-menu'] = userMenu;
  return mounted;
}